module.exports = __webpack_public_path__ + "static/media/criteria-10.1-rsp.8c9e88e3.jpg";